import {Handle, Position, useReactFlow} from '@xyflow/react';
import {NodeEditDialog, NodeEditDialogProps} from '../node-edit-dialog';
import {BaseNode} from './BaseNode';
import {NodeFeatures} from './types';
import TaskForm from '@/pages/resources/tasks/task-form';
import {useUpdate} from '@refinedev/core';
import {defaultMutationOptions} from '@/pages/_utils';
import formatter from '@/lib/formatter';
import DatepickerInput from '@/components/refinedev/DatepickerInput';

// Loại node bắt đầu của workflow

export const StartNode = (props: {data: any; selected?: boolean}) => {
  const {data = {}, selected} = props;
  return (
    <BaseNode selected={selected} className="rounded-lg bg-blue-100">
      <div className="flex flex-col w-full">
        <p className="self-center flex-grow text-blue-700 font-bold">Bắt đầu</p>
        <p className="text-xs">{formatter.formatDate(data.start_date)}</p>
      </div>
      {/* <Handle type="target" position={Position.Left} /> */}
      <Handle type="source" position={Position.Right} />
    </BaseNode>
  );
};

const EditDialog = (props: NodeEditDialogProps) => {
  const {dialogState} = props;
  const {resource, id: node_id, data} = dialogState?.extraData || {};
  const {updateNodeData} = useReactFlow();

  //   const update = useUpdate({resource, mutationOptions: defaultMutationOptions});

  // async function onSubmit(nodeData: any) {
  //   const data = transformBeforeSave(nodeData.data);
  //   console.log('submitted', data);
  //   // call remote api to create task
  //   // const transformedData = TaskForm.transformBeforeSave(nodeData.data);
  //   // await update.mutateAsync({id, values: transformedData});
  //   // add node to workflow
  //   updateNodeData(node_id, data);
  //   // close dialog
  //   dialogState.closeDialog();
  // }

  return (
    <NodeEditDialog title={`Ngày bắt đầu`} {...props} 
    // onSubmit={onSubmit}
    >
      <DatepickerInput source="start_date" label="Ngày bắt đầu" />
    </NodeEditDialog>
  );
};

function transformBeforeSave(data: any) {
  return {
    start_date: data.start_date ? formatter.formatDateSQL(data.start_date) : null,
  };
}

export const startNodeFeatures: NodeFeatures = {
  EditDialog,
};
